import { AppConstants } from '@core-lib/config';
import { AppLanguage } from '@core-lib/enums';
import { withEntityReducer } from '@core-lib/store';
import { Action, ActionReducer, createReducer, on, ReducerTypes } from '@ngrx/store';
import * as featureActions from './actions';
import { initialState, ISharedStoreState } from './state';

// declare our fully typed reducer
export function createSharedReducer<A extends Action = Action>(
	initialState,
	...ons: ReducerTypes<ISharedStoreState, any>[]
): ActionReducer<ISharedStoreState, A> {
	return createReducer(initialState, ...ons);
}

const featureReducer = createSharedReducer(
	initialState,

	...withEntityReducer<ISharedStoreState>('config', featureActions.ConfigActions),
	...withEntityReducer<ISharedStoreState>('referentials', featureActions.ReferentialsActions),
	on(featureActions.LoadTypesDocumentsSuccess, (state, action) => ({
		...state,
		typesDocuments: action.entity
	})),

	on(featureActions.InitLanguages, (state, action) => {
		const storedLang = localStorage.getItem(AppConstants.LOCALSTORAGE_KEYS.appLanguage) as AppLanguage;
		const newState = {
			...state
		};

		if (!storedLang) {
			localStorage.setItem(AppConstants.LOCALSTORAGE_KEYS.appLanguage, state.language);
		} else {
			newState.language = storedLang;
		}

		return {
			...newState
		};
	}),

	on(featureActions.SetLanguage, (state, action) => ({
		...state,
		language: action.param
	})),

	on(featureActions.AddToControlAutocomplete, (state, action) => ({
		...state,
		autocompleteData: null
	})),

	on(featureActions.AddToControlAutocompleteSuccess, (state, action) => {
		let autocompleteUpdatedTiers = [...state.autocompleteAddedTiers];
		if (autocompleteUpdatedTiers.find(x => x.value?.tempId === action.param?.data.filter(x => !x?.value?.id)[0]?.value?.tempId))
		{
			autocompleteUpdatedTiers = autocompleteUpdatedTiers.map(obj =>
				obj.value?.tempId === action.param?.data.filter(x => !x?.value?.id)[0]?.value?.tempId
					? {
						...obj,
						value : action.param?.data.filter(x => !x?.value?.id)[0]?.value,
						label : action.param?.data.filter(x => !x?.value?.id)[0]?.value?.formeJuridique ? `${action.param?.data.filter(x => !x?.value?.id)[0]?.value?.formeJuridique + ' ' + action.param?.data.filter(x => !x?.value?.id)[0]?.label}` : `${action.param?.data.filter(x => !x?.value?.id)[0]?.label}`,
					  }
					: obj
			);
			return {
				...state,
				autocompleteData: action.param,
				autocompleteAddedTiers: [...autocompleteUpdatedTiers]
			};
		}
		else{
			let addedTiers = action.param?.data.filter(x => !x?.value?.id)?.map(x => ({
				...x,
				index : state.autocompleteAddedTiers?.length +1,
			  })) ?? [];
			return {
				...state,
				autocompleteData: action.param,
				autocompleteAddedTiers: [...state.autocompleteAddedTiers, ...addedTiers]
			};
		}
	}),

	on(featureActions.ResetAutocompleteData, (state, action) => ({
		...state,
		autocompleteControlToReset: action.param,
		autocompleteData: null
	})),

	on(featureActions.ResetAutocompleteAddedTiers, (state, action) => ({
		...state,
		autocompleteAddedTiers: []
	})),

	on(featureActions.SetConfirmationModal, (state, action) => ({
		...state,
		confirmModal: action.param
	})),

	on(featureActions.SetCancelConfirmationModal, (state, action) => ({
		...state,
		cancelConfirmModal: action.param
	}))
);

export function sharedStoreReducer(state: ISharedStoreState, action: Action): ISharedStoreState {
	return featureReducer(state, action);
}
